var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.8438C0 8.90263 8.05888 0.84375 18 0.84375C27.9411 0.84375 36 8.90263 36 18.8438C36 28.7849 27.9411 36.8438 18 36.8438C8.05888 36.8438 0 28.7849 0 18.8438Z",
    fill: "url(#paint0_linear_929_978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 20.5104L9.25833 26.3438L26.75 18.8438L9.25833 11.3438L9.25 17.1771L13.4167 18.8438L9.25 20.5104Z",
    fill: "#F2F4F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_929_978",
    x1: 5.02653,
    y1: 5.46753,
    x2: 27.6515,
    y2: 33.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326577,
    stopColor: "#6E87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F75DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconEnable);
export default __webpack_public_path__ + "static/media/send_icon_enable.822e62289e349394124c4774fccb5d1a.svg";
export { ForwardRef as ReactComponent };